import styled from 'styled-components';
import { media } from '@mf/common/utils/styles/index';

export const Section = styled.section`
  margin-bottom: var(--spacing-3x);

  ${media.lessThan('mobile')} {
    max-width: 100%;
  }

  .inline-code {
    background-color: var(--color-grey-100);
    border: 1px solid var(--color-grey-200);
    font-size: 0.9rem;
    padding: var(--spacing-half);
    border-radius: 4px;
  }

  .code-block {
    background-color: var(--color-grey-100);
    border: 1px solid var(--color-grey-200);
    font-size: 0.9rem;
    padding: var(--spacing-2_5x);
    border-radius: 4px;
    width: 80%;
    margin: 0 auto;
    line-height: 1.25rem;
    color: var(--text-paragraph-color);
    white-space: break-spaces;
    overflow-wrap: break-word;

    ${media.lessThan('mobile')} {
      margin: var(--spacing-2_5x) 0;
      width: calc(100% - 42px);
    }
  }

  .image {
    img {
      margin: 0 auto;
      height: auto !important;
      width: auto !important;
      max-width: calc(100% - 10vw);
      position: relative !important;
    }
  }

  .anchor {
    text-decoration: underline;
  }

  li {
    font-family: var(--font-family-base);
    color: var(--text-paragraph-color);
  }

  .blockquote {
    border-left: 5px solid var(--color-grey-200);
    padding-left: var(--spacing-half);
    margin: 40px auto;
    width: 80%;

    ${media.lessThan('mobile')} {
      margin: var(--spacing-2_5x) 0;
      width: calc(100% - 12px);
    }
  }
`;
